import { Component, Input, OnInit } from '@angular/core';
import { CustomResponseData, SearchStatus, SearchRecord } from 'src/app/packages-module/models/searchPackage';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ToastrService } from 'ngx-toastr';
import { Screening, ScreeningLight, ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import * as _ from 'lodash';
import { ScreeningService } from '../../services/screening.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-records-manager',
  templateUrl: './custom-records-manager.component.html',
  styleUrls: ['./custom-records-manager.component.less']
})
export class CustomRecordsManagerComponent implements OnInit {

  screenshotLoaded : boolean = false;
  @Input() pkg : ScreeningAdditionalData;
  // customData : CustomResponseData[] = [];

  public get screeningToEdit() : ScreeningLight {
    return this.screening.screenings[0];
  }

  constructor(public appData: ApplicantDataService, public toast : ToastrService, public screening : ScreeningService,
    public domSanitizer : DomSanitizer){}
  ngOnInit(): void {
    this.loadCustomSearch()
  }
  lastSavedCustomSearchId : string;
  saveCustomSearchEdits(c : CustomResponseData) {
    if(this.lastSavedCustomSearchId == c.searchName) {
      return;
    }
    this.lastSavedCustomSearchId = c.searchName;
    // this.savingCustomSearchData = true;
    this.appData.SaveCustomSearchData(c).subscribe( res => {
      if(res) {
        c.searchStatusDisplay = c.customSearchStatus.toString();
        c.editing = false;
        this.toast.success(`${c.searchName} successfully updated!`);
        //if the screening is manual processing, then set the search status to pending review, otherwise complete
        this.pkg.searchStatus = this.screeningToEdit.manualProcessing ? 6 : 8;
      } else {
        this.toast.error(`${c.searchName} failed to update!`, '', { closeButton: true, disableTimeOut: true })
      }
    },
    (error) => {
      this.toast.error(`${c.searchName} failed to update!`, '', { closeButton: true, disableTimeOut: true });
    })
  }

  public loadCustomSearch(): void {
    this.appData.customSearchRecords = [];
      // this.ase = pkg;
      //first check to see if the CustomResponseRecord(s) exist for this screening token. If not, create some stubs
      this.appData.GetCustomSearchResponseRecords(this.pkg.searchEntryId).subscribe((results : CustomResponseData[]) => {
        if(results && results.length > 0) {
          results.forEach(r => this.appData.customSearchRecords.push(r));
        }
        this.appData.GetCustomSearchRecordStubs(this.pkg.searchEntryId).subscribe((res : SearchRecord[]) => {
          if(res) {
            _.forEach(res, rec => {
              if(!this.appData.customSearchRecords.find(s =>{ return s.searchName == rec.name})){
                let customData = new CustomResponseData();
                customData.inviteToken = this.screeningToEdit.screeningToken;
                customData.orderId = rec.orderId ?? 0;
                customData.searchEntryId = this.pkg.searchEntryId;
                customData.customSearchDescription = '';
                customData.searchName = rec.name;
                customData.recordFound = false;
                customData.customSearchStatus = SearchStatus.NotRun;
                customData.searchStatusDisplay = SearchStatus[customData.customSearchStatus];
                customData.editing = false;
                this.appData.customSearchRecords.push(customData);
              }
            })

          }
        },
        (error) => {
          this.toast.error('Error fetching your custom search records', '', { closeButton: true, disableTimeOut: true })
        })
      },
      (error) => {
        this.toast.error('Error fetching your custom search records', '', { closeButton: true, disableTimeOut: true })
      })

  }

  loadImage(crd : CustomResponseData) :SafeResourceUrl {
    if(!this.screenshotLoaded) {
      this.screenshotLoaded = true;
      return this.domSanitizer.bypassSecurityTrustResourceUrl(crd.customSearchDescription);
    }
  }

  public handleImageUpload(crd : CustomResponseData, event : any) {
    if(event.target.files && event.target.files[0]) {
      let reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (event) => {
        let r = <FileReader>event.currentTarget;
        crd.customSearchDescription = r.result.toString();
      }
    }
  }
}
